<!--附近景点 美食-->
<template>
    <div class="NearbyPoint">
        <div v-if="list.length>0">
        <div class="nearbyBox" v-for="(item,ix) in list" :key="`near-by-po-${ix}`" @click="onAction(item.name,item.id)" >
            <div class="pointImg singleRadius">
                <img :src="item.imgUrl" :alt="item.name" class="poImgCls"/>
            </div>
            <div class="pointDetails">
                <div class="nameStar">
                    <div class="nameArea">{{item.name||"地名"}}</div>
                    <div class="distance" v-if="pointType=='scenery'">{{item.distance}}</div>
                </div>
                <div class="starBox">
                    <div v-for="(it,ix) in createArray(item.star>5?5:item.star)" :key="`it-${ix}`" class="arrayBox">
                        <img :src="require(`../../assets/img/${it.star}.png`)" :alt="item.name" class="starImg"
                             v-if="pointType=='scenery'"/>
                        <img :src="require(`../../assets/img/${it.star}.png`)" :alt="item.name" class="starImg" v-if="pointType=='food'"/>
                    </div>
                </div>
                <div class="area"> {{`${pointType=="scenery"?`地点：${item.area}`:` ${item.distance}`}`}}</div>
            </div>
        </div>
    </div>
        <div v-else>暂无数据</div>
    </div>

</template>

<script>
    import {createArray} from "@/utils/utils";
    import {mapState, mapActions, mapMutations} from "vuex";

    export default {
        name: "NearbyPoint",
        components: {},
        props: {
            list: {
                type: Array,
                default: () => []
            },
            pointType: {
                type: String,
                default: "food" //美食  //'scenery'风景
            }

        },
        data() {
            return {};

        },
        methods: {
            ...mapMutations([
                "contactDisData", "setGlobalDuration", "setChatLoading","setToastShow","setToastContent"
            ]),
            ...mapActions(["getTourInfo"]),
            createArray(n) {
                return createArray(n,this.pointType=='food'?2:1);
            },
            onTourDetails(name, id) {
                let that = this;
                this.setChatLoading(true);
                this.setGlobalDuration(0);
                this.contactDisData([{content: {right: true, tips: `小封小封，我想去${name}`}}]);
                this.getTourInfo({payload: {id}}).then((res) => {
                    if (res.length) {
                        that.setChatLoading(false);
                        that.setToastShow(false)
                    }
                    setTimeout(() => {
                        that.service.pageScrollTo();
                    }, 100);
                });
            },
            onAction(name, id) {
                if (this.pointType == "scenery") {
                    this.onTourDetails(name, id);
                }else {
                    cio.track(6,'click', "food_click");
                    this.setToastShow(true)
                    this.setToastContent({toastType: 0,list:{name:'',content:'查看美食详情功能暂未开放，再给小封一点时间哦~'}})
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    .NearbyPoint {
        .nearbyBox {
            background: rgba(255, 255, 255, 1);
            border-radius: 6px;
            border: 1px solid rgba(238, 242, 249, 1);
            padding: .2rem .25rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: .6rem;

            .pointImg {
                width: 2.3rem;
                height: 2.2468rem;
                overflow: hidden;
                margin-right: .4rem;

                .poImgCls {
                    width: 100%;
                    height: 100%;
                    max-width: 100%;
                }

            }

            .pointDetails {
                width: 6rem;

            }
        }


    }

</style>
